import { Notification, SendToAllEnum } from "@/types";
import { NewNotificationSchemaType } from "../schemas";

export function parseNotificationToFormValues(
  notification: Notification
): NewNotificationSchemaType {
  return {
    send_time: notification.send_time,
    title: notification.title,
    description: notification.description,
    manager: notification.manager,
    status: notification.status,
    stores:
      notification.notificationsStore?.map((item) => ({
        value: item.store_id,
        label: item.store?.name,
      })) || [],
    groups:
      notification.notificationsGroup?.map((item) => ({
        value: item.group_id,
        label: item.group?.name,
      })) || [],
    storeUsers:
      notification.notificationsUser?.map((item) => ({
        value: item.user_id,
        label: item.user?.full_name,
        description: item.user?.email,
      })) || [],
    fileItems:
      notification.attachments?.map((item) => ({
        id: item.id,
        name: item.name,
        url: item.url,
        type: item.type,
      })) || [],
    send_to_all_stores: notification.send_to_all_stores
      ? SendToAllEnum.ALL
      : notification.notificationsStore?.length
      ? SendToAllEnum.OPTIONAL
      : SendToAllEnum.NONE,

    send_to_all_groups: notification.send_to_all_groups
      ? SendToAllEnum.ALL
      : notification.notificationsGroup?.length
      ? SendToAllEnum.OPTIONAL
      : SendToAllEnum.NONE,
    send_to_all_users: notification.send_to_all_users
      ? SendToAllEnum.ALL
      : notification.notificationsUser?.length
      ? SendToAllEnum.OPTIONAL
      : SendToAllEnum.NONE,
  };
}
